import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './LinkPreview.css';
import { FaSpinner, FaLink, FaTimes } from 'react-icons/fa';

const LinkPreview = ({ 
  isLoadingPreview, 
  linkPreview, 
  onRemovePreview 
}) => {
  if (isLoadingPreview) {
    return (
      <div className="lp-loading">
        <FaSpinner className="lp-loading-icon" />
        <span>Chargement de l'aperçu...</span>
      </div>
    );
  }

  if (!linkPreview) return null;

  return (
    <div className="lp-container">
      <div className="lp-header">
        <span className="lp-label">
          <FaLink className="lp-icon" />
          Aperçu du lien
        </span>
        <div className="lp-close" onClick={onRemovePreview}>
          <FaTimes size={14} />
        </div>
      </div>
      <div className="lp-content">
        {linkPreview.image && (
          <div className="lp-image">
            <img src={"https://peupleqc.com/s/peupleqc-upload/"+linkPreview.image} alt="Preview" />
          </div>
        )}
        <div className="lp-text">
          <h4 className="lp-title">{linkPreview.title}</h4>
          <p className="lp-description">{linkPreview.description}</p>
          <span className="lp-url">{linkPreview.url}</span>
        </div>
      </div>
    </div>
  );
};

export default LinkPreview;
export {LinkPreview};